<template>
  <v-autocomplete
    :menu-props="{
      maxHeight: 400
    }"
    color="primary"
    variant="outlined"
    density="comfortable"
    persistent-hint
  >
    <template v-if="$slots.item" #item="{ item, props }">
      <v-list-item v-bind="props" #title>
        <slot name="item" :item />
      </v-list-item>
    </template>

    <template v-if="$slots.selection" #selection="{ item }">
      <slot name="selection" :item />
    </template>
  </v-autocomplete>
</template>